import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { Breadcrumb, BreadcrumbLink } from '@instructure/ui-breadcrumb';
export function HeaderBreadCrumb(_ref) {
  var _ref$returnToUrl = _ref.returnToUrl,
    returnToUrl = _ref$returnToUrl === void 0 ? null : _ref$returnToUrl,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? {} : _ref$scope,
    _ref$navigateToBuild = _ref.navigateToBuild,
    navigateToBuild = _ref$navigateToBuild === void 0 ? null : _ref$navigateToBuild,
    _ref$navigateToBanks = _ref.navigateToBanks,
    navigateToBanks = _ref$navigateToBanks === void 0 ? null : _ref$navigateToBanks,
    _ref$renderIcon = _ref.renderIcon,
    renderIcon = _ref$renderIcon === void 0 ? null : _ref$renderIcon,
    _ref$setItemBanksRef = _ref.setItemBanksRef,
    setItemBanksRef = _ref$setItemBanksRef === void 0 ? null : _ref$setItemBanksRef,
    _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var itemBanksRef = useRef(null);
  useEffect(function () {
    // Note: InstUI doesn't handle refs properly, so we need to unwrap the link manually and
    // focus the button within it.
    if (navigateToBuild && navigateToBanks && itemBanksRef.current && !setItemBanksRef) {
      var itemBanksElement = ReactDOM.findDOMNode(itemBanksRef.current);
      if (itemBanksElement && itemBanksElement.querySelector('button')) {
        itemBanksElement.querySelector('button').focus();
      }
    }
  }, [navigateToBuild, navigateToBanks, setItemBanksRef]);
  var isScopeEmpty = !Object.keys(scope).length;
  var canvasReferrerLinkText = isScopeEmpty ? null : scope.title;
  var canvasReferrerLink = returnToUrl && canvasReferrerLinkText && /*#__PURE__*/React.createElement(BreadcrumbLink, {
    key: "Context",
    href: returnToUrl,
    target: "_top"
  }, canvasReferrerLinkText);
  var banksLink = /*#__PURE__*/React.createElement(BreadcrumbLink, {
    key: "Banks",
    onClick: navigateToBanks,
    renderIcon: renderIcon,
    ref: setItemBanksRef || itemBanksRef
  }, t('Item Banks'));

  // If Breadcrumb has multiple children (even if 2nd is null), it will
  // render the `>` icon, which we don't want if there are no children.
  var breadCrumbLinks = [banksLink];
  if (children) {
    breadCrumbLinks = breadCrumbLinks.concat(children);
  }
  if (canvasReferrerLink) {
    breadCrumbLinks.unshift(canvasReferrerLink);
  }
  return /*#__PURE__*/React.createElement(Breadcrumb, {
    label: t('You are here:'),
    size: isCompact ? 'small' : 'medium'
  }, breadCrumbLinks);
}
HeaderBreadCrumb.propTypes = {
  returnToUrl: PropTypes.string,
  scope: PropTypes.objectOf(PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string
  })),
  navigateToBuild: PropTypes.func,
  navigateToBanks: PropTypes.func,
  isCompact: PropTypes.bool,
  setItemBanksRef: PropTypes.func,
  renderIcon: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default HeaderBreadCrumb;